import { createRouter, createWebHistory } from 'vue-router'
import Layout from "@/components/layout";

// 基础路由（所有用户都可以访问）
const constantRoutes = [
  {
    path: "/",
    redirect: "/dashboard/index",
    component: Layout,
  },
  {
    path: "/login",
    hidden: true,
    component: () => import("@/views/login/index")
  },
  {
    path: "/auth-redirect",
    hidden: true,
    component: () => import("@/views/login/auth-redirect")
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: { title: 'Dashboard', roles: ['admin', 'agent', 'crawl'] },
    children: [
      {
        name: "Dashboard",
        path: "index",
        component: () => import("@/views/dashboard/index"),
      }
    ]
  },
  // {
  //   path: "/404",
  //   hidden: true,
  //   component: () => import("@/views/error-page/404")
  // },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/404",
  //   hidden: true
  // }
]

// 异步路由（需要权限控制）
const asyncRoutes = [
  {
    path: "/agent",
    icon: "agent",
    redirect: "/agent/list",
    component: Layout,
    meta: { roles: ['admin', 'agent'] },
    children: [
      {
        name: "Agent List",
        path: "list",
        meta: { 
          title: "Agent(List)", 
          roles: ['admin', 'agent'] 
        },
        component: () => import("@/views/agent/list"),
      },
      {
        name: "Agent Detail",
        path: "detail/:agentId(\\d+)",
        meta: { 
          title: "Agent(Detail)", 
          activeMenu: "/agent/list", 
          noCache: true,
          roles: ['admin', 'agent'] 
        },
        hidden: true,
        component: () => import("@/views/agent/detail"),
      },
      {
        name: "Agent Service",
        path: "service",
        meta: { 
          title: "Agent(Service)", 
          roles: ['admin', 'agent'] 
        },
        hidden: true,
        component: () => import("@/views/agent/service"),
      },
    ]
  },
  {
    path: "/customer",
    icon: "customer",
    redirect: "/customer/list",
    component: Layout,
    meta: { roles: ['admin', 'agent'] },
    children: [
      {
        name: "Customer List",
        path: "list",
        meta: { 
          title: "Customer(List)", 
          roles: ['admin'] 
        },
        component: () => import("@/views/customer/list"),
      },
      {
        name: "Customer Detail",
        path: "detail/:customerId(\\d+)",
        meta: { 
          title: "Customer(Detail)", 
          activeMenu: "/customer/list", 
          noCache: true,
          roles: ['admin'] 
        },
        hidden: true,
        component: () => import("@/views/customer/detail"),
      },
      {
        name: "Customer Service",
        path: "service/:customerId(\\d+)/:agentId(\\d+)?",
        meta: { 
          title: "Customer(Service)", 
          roles: ['admin', 'agent'] 
        },
        hidden: true,
        component: () => import("@/views/customer/service"),
      },      
    ]
  },  
  {
    path: "/news",
    icon: "news",    
    redirect: "/news/list",
    component: Layout,
    meta: { roles: ['admin'] },
    children: [
      {
        name: "News List",
        path: "list",
        meta: { 
          title: "News(List)", 
          roles: ['admin'] 
        },
        component: () => import("@/views/news/list"),
      },      
      {
        name: "News Detail",
        path: "detail/:newsId(\\d+)",
        meta: { 
          title: "News(Detail)", 
          activeMenu: "/news/list", 
          noCache: true,
          roles: ['admin'] 
        },
        hidden: true,
        component: () => import("@/views/news/detail"),
      },
    ]
  },
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

// 重置路由的方法
router.resetRouter = function() {
  const newRouter = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: constantRoutes
  })
  this.matcher = newRouter.matcher
}

// 动态添加路由的方法
router.addRoutes = function(routes) {
  routes.forEach(route => {
    this.addRoute(route)
  })
}

export { constantRoutes, asyncRoutes }
export default router